import gql from "graphql-tag";

export const soundFileLibraryQuery = gql(`
    query GetSoundFileLibrary($areaId: String!) {
        getSoundFileLibrary(areaId: $areaId) {
            id
            areaId
            objectId
            originalFileName
            filePath
            uploadedBy
            mimeType
            sizeBytes
            durationMs
            lastUsedPublishedAt
            lastUsedPublishedVersionName
            purgedAt
            purgedBy
            createdAt
            updatedAt
        }
    }
`);

export const registerSoundFileMutation = gql(`
    mutation RegisterSoundFile($areaId: String!, $objectId: String!, $originalFileName: String!, $filePath: String!, $uploadedBy: String, $mimeType: String, $sizeBytes: Float, $durationMs: Float) {
        registerSoundFile(areaId: $areaId, objectId: $objectId, originalFileName: $originalFileName, filePath: $filePath, uploadedBy: $uploadedBy, mimeType: $mimeType, sizeBytes: $sizeBytes, durationMs: $durationMs) {
            objectId
            originalFileName
            filePath
        }
    }
`);

export const deleteSoundFileLibraryEntriesMutation = gql(`
    mutation DeleteSoundFileLibraryEntries($areaId: String!, $objectIds: [String]!) {
        deleteSoundFileLibraryEntries(areaId: $areaId, objectIds: $objectIds) {
            message
        }
    }
`);

export const purgeSoundFilesMutation = gql(`
    mutation PurgeSoundFiles($areaId: String!, $objectIds: [String!]!) {
        purgeSoundFiles(areaId: $areaId, objectIds: $objectIds) {
            message
        }
    }
`);